var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLashesUpNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 38,
    viewBox: "0 0 135 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 135,
    height: 38
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_99",
    x: 83.757,
    y: 6.141,
    width: 42.78,
    height: 15.701,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#75798c",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_98",
    x: 8.269,
    y: 6.2,
    width: 42.44,
    height: 15.796,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#75798c",
    floodOpacity: 0.588
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lashes-up-new",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lashes-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right",
    transform: "translate(86.757 4.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(39.434 12.374) rotate(-172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M4.873.07A6.479,6.479,0,0,0,3.148.036,3.484,3.484,0,0,0,.87,1.18C-.563,2.828.206,5.415.206,5.415a5.475,5.475,0,0,1,1.9-4.024A4.2,4.2,0,0,1,6.332,1.03S3.6.662,2.712,2.195a6.286,6.286,0,0,0-.5,3.7A6.142,6.142,0,0,1,3.854,2.33a4.118,4.118,0,0,1,3.737-.678s-2.4.224-2.924,1.454a8.673,8.673,0,0,0-.324,3.355s.23-2.421,1.594-3.422A5.751,5.751,0,0,1,9.584,2.38Z",
    transform: "translate(0.338) rotate(3)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(7.123 2.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128-2",
    "data-name": "Path 128",
    d: "M4.991.013S1.5-.187.469.988.425,3.91.425,3.91A3.285,3.285,0,0,1,1.636,1.163C3.019.086,6.039.7,6.039.7s-1.959-.262-2.6.83a4.3,4.3,0,0,0-.171,2.8A3.928,3.928,0,0,1,4.26,1.623,2.976,2.976,0,0,1,6.944,1.14s-1.721.16-2.1,1.037a1.971,1.971,0,0,0,.087,1.665,1.879,1.879,0,0,1,.824-1.713,4.158,4.158,0,0,1,2.619-.47Z",
    transform: "translate(0.227) rotate(3)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(13.807 3.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128-3",
    "data-name": "Path 128",
    d: "M3.941.085S1.682-.316.64.626.14,3.314.14,3.314A3.525,3.525,0,0,1,1.661.789,4.332,4.332,0,0,1,4.981.616S3.026.429,2.374,1.3a2.757,2.757,0,0,0-.2,2.224A2.782,2.782,0,0,1,3.193,1.369,3.666,3.666,0,0,1,5.88.957S4.158,1.1,3.771,1.8A1.275,1.275,0,0,0,3.84,3.12a1.4,1.4,0,0,1,.842-1.366,5.172,5.172,0,0,1,2.623-.4Z",
    transform: "translate(0.185) rotate(3)",
    fill: "#62616d"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -86.76, -4.41)",
    filter: "url(#Path_99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99-2",
    "data-name": "Path 99",
    d: "M18.655-1.251C10.1-1.251,0,6.422,0,6.422S9.616,2.164,18.166,2.164,36.78,8.45,36.78,8.45,27.2-1.251,18.655-1.251Z",
    transform: "translate(86.76 9.39)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-3",
    "data-name": "Path 99",
    d: "M18.655-1.251C10.1-1.251,0,6.422,0,6.422S9.616,2.164,18.166,2.164,36.78,8.45,36.78,8.45,27.2-1.251,18.655-1.251Z",
    transform: "translate(0 4.98)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "left",
    transform: "translate(8.021 4.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0 4.847) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74-2",
    "data-name": "Group 74",
    transform: "translate(0 0.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128-4",
    "data-name": "Path 128",
    d: "M4.873,6.391a6.479,6.479,0,0,1-1.725.034A3.484,3.484,0,0,1,.87,5.282C-.563,3.634.206,1.046.206,1.046a5.475,5.475,0,0,0,1.9,4.024,4.2,4.2,0,0,0,4.223.361S3.6,5.8,2.711,4.266a6.286,6.286,0,0,1-.5-3.7,6.142,6.142,0,0,0,1.646,3.57,4.118,4.118,0,0,0,3.737.678S5.194,4.59,4.67,3.36A8.673,8.673,0,0,1,4.344,0s.229,2.421,1.593,3.422a5.751,5.751,0,0,0,3.647.659Z",
    transform: "translate(0 0.502) rotate(-3)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76-2",
    "data-name": "Group 76",
    transform: "translate(7.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128-5",
    "data-name": "Path 128",
    d: "M4.991,4.318S1.5,4.517.469,3.343.425.421.425.421A3.285,3.285,0,0,0,1.636,3.168c1.383,1.077,4.4.466,4.4.466S4.08,3.9,3.44,2.8A4.3,4.3,0,0,1,3.268,0,3.928,3.928,0,0,0,4.26,2.707a2.976,2.976,0,0,0,2.684.484s-1.721-.16-2.1-1.037A1.971,1.971,0,0,1,4.932.489,1.879,1.879,0,0,0,5.756,2.2a4.158,4.158,0,0,0,2.619.47Z",
    transform: "translate(0 0.438) rotate(-3)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77-2",
    "data-name": "Group 77",
    transform: "translate(13.807 0.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128-6",
    "data-name": "Path 128",
    d: "M3.941,3.441s-2.259.4-3.3-.541S.141.212.141.212a3.525,3.525,0,0,0,1.52,2.525,4.332,4.332,0,0,0,3.32.173s-1.955.19-2.607-.686A2.757,2.757,0,0,1,2.172,0,2.782,2.782,0,0,0,3.193,2.156a3.665,3.665,0,0,0,2.687.412s-1.722-.145-2.109-.844A1.275,1.275,0,0,1,3.84.4a1.4,1.4,0,0,0,.842,1.366,5.172,5.172,0,0,0,2.623.4Z",
    transform: "translate(0 0.382) rotate(-3)",
    fill: "#62616d"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.02, -4.41)",
    filter: "url(#Path_98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98-2",
    "data-name": "Path 98",
    d: "M15.852-1.182c8.55,0,18.166,7.609,18.166,7.609S24.4,2.169,15.852,2.169-2.422,8.614-2.422,8.614,7.3-1.182,15.852-1.182Z",
    transform: "translate(13.69 9.38)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_98-3",
    "data-name": "Path 98",
    d: "M15.852-1.182c8.55,0,18.166,7.609,18.166,7.609S24.4,2.169,15.852,2.169-2.422,8.614-2.422,8.614,7.3-1.182,15.852-1.182Z",
    transform: "translate(5.67 4.97)",
    fill: "#62616d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLashesUpNew);
export default __webpack_public_path__ + "static/media/lashes-up-new.aeb88071654b826ffb689d1e009120f7.svg";
export { ForwardRef as ReactComponent };